export default __webpack_public_path__ + "static/media/resume.c7adbad4.png";